module.exports = __webpack_public_path__ + "media/images/default-avatar-63ad85b8d3db6187a5001db6ab237184.png";